import { render, staticRenderFns } from "./CardIdentifierItem.vue?vue&type=template&id=4db8d397"
import script from "./CardIdentifierItem.vue?vue&type=script&lang=js"
export * from "./CardIdentifierItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports